<script>
/**
 * Page-header compponent
 */
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
    prev: {
      type: Object,
      default: () => {
        return {}
      },
    },
    backButton: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  methods: {
    goBack(){
      try {
        console.log("Go back",JSON.stringify(this.prev));
        // this.$router.push(
        //   this.$route.query.redirectFrom || {
        //     name: this.prev.name, params: this.prev.params
        //   }
        // );
        this.$router.go(-1);
      } catch (error) {
        console.log("Can't go back", error);
      }
    }
  },
}
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-8">
      <div class="page-title-box d-flex align-items-center">
        <button type="button" class="btn btn-primary btn-sm me-4" @click="goBack" v-if="backButton">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
          </svg>
        </button>
        <b-breadcrumb :items="items" class="m-0 text-capitalize"></b-breadcrumb>
      </div>
    </div>
    <div class="col-4">
      <h4 class="mb-0 font-size-18 float-end">{{ title }}</h4>
    </div>
  </div>
  <!-- end page title -->
</template>
